import { connect } from "react-redux";
import selectors from "./selectors";
// import dispatchers from "./dispatchers";
import CardDetailUI from "./CardDetailUI";

export default connect(selectors)(CardDetailUI);
